/**
 * Imports only the main UI themes HTML elements (tags)
 *
 */

import './dnb-ui-elements.scss'
